import { render, staticRenderFns } from "./footBar.vue?vue&type=template&id=94c732ba&scoped=true"
import script from "./footBar.vue?vue&type=script&lang=js"
export * from "./footBar.vue?vue&type=script&lang=js"
import style0 from "./footBar.vue?vue&type=style&index=0&id=94c732ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c732ba",
  null
  
)

export default component.exports